<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Elenco Incarichi</h1>

    <!-- <loading-spinner v-if="loading" /> -->
    <div class="row justify-content-between mx-2 mt-5 mb-2 align-middle">
      <h4>Elenco incarichi</h4>
      <div class="text-right">
        <b-button
          variant="primary"
          @click="onNewDocumentClick"
        >
          <font-awesome-icon
            icon="plus"
            class="mr-2"
          />Aggiungi
        </b-button>
      </div>
    </div>

    <b-alert
      v-if="!loading && !items.length"
      show
      variant="info"
      class="my-4"
    >
      Non sono presenti incarichi in archivio.
      Premere il tasto "<a
        href="#"
        class="alert-link"
        @click="onNewDocumentClick"
      >Aggiungi </a>" per inserirne uno nuovo.
    </b-alert>
    <b-table
      v-else-if="items.length"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      :responsive="true"
      :busy="false"
      @row-clicked="onRowClicked"
    >

      <template v-slot:head(icon)>
        <font-awesome-icon
          icon="file-alt"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(icon)="data">
        <!-- <font-awesome-icon v-if="data.item.stato === 'A'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <!-- <font-awesome-icon v-if="data.item.stato === 'C'" icon="search" size="lg" class="text-success cursor-pointer"/> -->
        <font-awesome-icon
          v-if="data.item.ownerista === 'GIQ'"
          icon="check"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato === 'B'"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <!-- <font-awesome-icon v-if="data.item.stato === 'P'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'search')"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'pen')"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato === 'V'"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <!-- <pre v-if="isDevelopmentMode">{{data.item.id}}</pre> -->
      </template>

    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </div>
      <div class="text-right">
        <b-form-group
          description="Per pagina"
          class="mb-0"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import moment from 'moment-timezone'
// import LoadingSpinner from '@/components/LoadingSpinner'

const formatValidData = (value, strFormat) => {
  let retValue = ''

  strFormat = strFormat || 'DD/MM/YYYY'

  if (moment(value, 'YYYY-MM-DD', false).isValid()) {
    // retValue = moment(value, 'YYYY-MM-DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else if (moment(value, 'YYYY/MM/DD', false).isValid()) {
    // retValue = moment(value, 'YYYY/MM/DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else {
    // retValue = moment(value, 'DD/MM/YYYY', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  }

  // console.log('Data in format', value, retValue, moment(value).locale('it').tz('Europe/Rome').format('DD MMMM YYYY HH:mm'))
  return moment(retValue, strFormat).isValid() ? retValue : ' - '
}

export default {
  components: {
    // LoadingSpinner
  },
  data () {
    return {
      fields: [
        'icon',
        { key: 'tipo', label: 'Tipo' },
        { key: 'data', label: 'Data', formatter: (value) => { return formatValidData(value, 'DD/MM/YYYY') } },
        // { key: 'cftitolare', label: 'CF titolare' },
        { key: 'titolare', label: 'Titolare' },
        // { key: 'cfncaricato', label: 'CF incaricato' },
        { key: 'incaricato', label: 'Incaricato' },
        { key: 'codiceUtente', label: 'Codice RU' },
        { key: 'codiceUib', label: 'Codice BU' },
        // { key: 'indirizzo', label: 'Indirizzo' },
        // { key: 'abilitato', label: 'Abilitato' },
        { key: 'statoAbilitazione', label: 'Stato Abilitazione' },
        { key: 'fineAbilitazione', label: 'Fine Validità', formatter: (value) => { return formatValidData(value, 'DD/MM/YYYY') } }
      ],
      loading: true,
      items: [],
      item: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      codiceUib: null,
      codiceUibOptions: null
    }
  },

  async created () {
    await this.load()
  },

  computed: {
    isDevelopmentMode () {
      let retValue = process.env.NODE_ENV && process.env.NODE_ENV.trim() === 'development'
      // console.log('isDevelopmentMode ', retValue)
      return retValue
    }
  },
  methods: {

    back () {
      this.$router.push({ name: 'home' })
    },

    async load () {
      try {
        this.loading = true
        await this.$store.dispatch('incarichi/loadItems')
        this.items = this.$store.state.incarichi.items

        // console.log('Situazione store', this.items)

        await Promise.all([
          this.$store.dispatch('options/loadTipoIstanzaOptions'),
          this.$store.dispatch('options/loadUnitaImmobiliareOptions')
        ])

        this.codiceUib = (this.$store.state.options.unitaImmobiliare ? this.$store.state.options.unitaImmobiliare[0] : {}).value
        this.codiceUibOptions = (this.$store.state.options.unitaImmobiliare ? this.$store.state.options.unitaImmobiliare[0] : {})
        // console.log('Incarichi caricate: ', this.items)
      } catch (err) {
        // console.log('Errore in load Lista Incarichi', this.$store.state)
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista degli invarichi esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    async onNewDocumentClick () {
      // this.$router.replace({ name: 'incarico' })
      try {
        // console.log('Crea richiesta nuovo incarico')
        let rs = await this.$store.dispatch('incarichi/addNew', { codiceUib: this.codiceUib })
        // this.close()
        this.$router.push({ name: 'incarico', params: { id: rs.id } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    },

    onRowClicked (row) {
      // console.log('Accedi a una richiesta di icarico', row)
      if (row.ownerista !== 'GIQ') {
        this.$router.push({ name: 'incarico', params: { id: row.id } })
      }
    },

    urlIstanza (id, owner) {
      // console.log('urlIncarico', id)
      let urlString
      if (owner) {
        urlString = `/api/istanze/${id}/download?ext=${owner === 'GIQ' ? '1' : '0'}`
      } else {
        urlString = `/api/istanze/${id}/download`
      }
      return urlString
    },
    isEditable (currentRow, idScope) {
      let retValue = false

      // console.log('idScope: ', idScope)
      if (idScope === 'search') {
        retValue = currentRow.editable !== null
      } else {
        retValue = currentRow.stato === 'P' && currentRow.editable !== 'NO'
      }
      // console.log('Riga corrente: ', currentRow.stato, currentRow.editable, retValue)
      return retValue
    }

  }
}
</script>
